const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const cdnUrl = "https://site.gcores.com"

const title = "胆小勿点，莫找罪受｜2023中元节特别企划"
const desc = "分享我们的中元节播客、游戏、文章"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: "一年一度的中元夜话回来了",
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    radio2023Url: "https://www.gcores.com/radios/170016",
    bestTvUrl: "https://www.gcores.com/topics/18",
  },
}
